export enum MyDeviceFormControlName {
  REGISTERED_DEVICES = 'registered-devices',
  NEW_DEVICES = 'new-devices'
}

export enum DeviceUserFormControlName {
  SERIAL = 'serial',
  PASSPHRASE = 'passphrase'
}
